 //const BASE_URL = "http://192.168.1.148/vone_system";
//const BASE_URL = "http://192.168.1.254/oakya_dev/vone/api"
//live url
//const BASE_URL  = "https://v1.oakyaitservices.in/api"
// demo live url
//const BASE_URL  = "https://vonedev.oakyaitservice.com/api"
//client demo live url
//const BASE_URL  = "http://demo.jksoftech.in/api"
//const BASE_URL  = "https://v1electricalsolutions.com/api"
//v1electrician solutions
//const BASE_URL  = "https://v1electricalsolutions.com/vonecontrolpanel/api"

// demo test for v1 electrical solutions

const BASE_URL  =  "https://demotest.v1electricalsolutions.com/api"

const API_URLS = {
  getqrcodeimages: {
    url: `${BASE_URL}/qrcodes/`,
  },

  // In your API_URLS configuration
  getqrcodefile: {
    url: `${BASE_URL}/qrcodes/qr_code_pdf_files/`,
  },

  getElecticianImages: {
    url: `${BASE_URL}/electrician/`,
  },

  getDelearImages: {
    url: `${BASE_URL}/dealer/`,
  },

  getrepresentativeimages: {
    url: `${BASE_URL}/representative/`,
  },

  getBannerImages: {
    url: `${BASE_URL}/banners/`,
  },

  //gift schema images
  getElecticianGiftImages: {
    url: `${BASE_URL}/electrician_gift_scheme/`,
  },

  getDealerGiftImages: {
    url: `${BASE_URL}/dealer_gift_scheme/`,
  },

  getDealerOrderImages: {
    url: `${BASE_URL}/dealer_orderdetails/`,
  },

  getDispatchDealerImages: {
    url: `${BASE_URL}/dealer_redeem_gift/`,
  },
  //admin profile

  getElectricianDispatchImages: {
    url: `${BASE_URL}/electrician_redeem_gift/`,
  },

  getDispatchDealerImages: {
    url: `${BASE_URL}/dealer_redeem_gift/`,
  },

  getgroupImages: {
    url: `${BASE_URL}/dealer_stock_group/`,
  },

  getproductsImages: {
    url: `${BASE_URL}/dealer_products/`,
  },

  getimagepathforsales: {
    url: `${BASE_URL}/talley_data/dealer_sales/sales_images/`,
  },

  getimagepathforcredit: {
    url: `${BASE_URL}/talley_data/dealer_credit_note/credit_note_images/`,
  },

  getimagepathfordebit: {
    url: `${BASE_URL}/talley_data/dealer_debit_note/debit_note_images/`,
  },

  adminLogin: {
    url: `${BASE_URL}/admin/login.php`,
    method: "POST",
  },

  adminProfileretrieve: {
    url: `${BASE_URL}/admin/retrieve.php`,
    method: "POST",
  },

  CreateEmployee: {
    url: `${BASE_URL}/admin/create.php`,
    method: "POST",
  },

  UpdateEmployee: {
    url: `${BASE_URL}/admin/update.php`,
    method: "POST",
  },

  changepasswordEmployee: {
    url: `${BASE_URL}/admin/update.php`,
    method: "PUT",
  },

  getAllEmployees: {
    url: `${BASE_URL}/admin/retrieve.php`,
    method: "GET",
  },

  getEmployeesDetails: {
    url: `${BASE_URL}/admin/admin_retrieve.php`,
    method: "GET",
  },

  //admin electrician points

  CreateElectricianPoints: {
    url: `${BASE_URL}/admin_electrician_points/create.php`,
    method: "POST",
  },

  getAdminElectricianPoints: {
    url: `${BASE_URL}/admin_electrician_points/retrieve.php`,
    method: "GET",
  },

  getAllAdminTransaction: {
    url: `${BASE_URL}/admin_electrician_points/transaction.php`,
    method: "GET",
  },

  //company api's
  createcompany: {
    url: `${BASE_URL}/company/create.php`,
    method: "POST",
  },
  updatecompany: {
    url: `${BASE_URL}/company/update.php`,
    method: "POST",
  },
  getAllcompanys: {
    url: `${BASE_URL}/company/admincompany.php`,
    method: "GET",
  },
  getActivecompany: {
    url: `${BASE_URL}/company/retrieve.php`,
    method: "GET",
  },

  //group api's
  creategroup: {
    url: `${BASE_URL}/group/create.php`,
    method: "POST",
  },
  updategroup: {
    url: `${BASE_URL}/group/update.php`,
    method: "POST",
  },
  getAllgroup: {
    url: `${BASE_URL}/group/admingroup.php`,
    method: "GET",
  },
  getActivegroup: {
    url: `${BASE_URL}/group/retrieve.php`,
    method: "GET",
  },

  //manager api's
  createmanager: {
    url: `${BASE_URL}/manager/create.php`,
    method: "POST",
  },
  updatemanager: {
    url: `${BASE_URL}/manager/update.php`,
    method: "POST",
  },
  getAllmanager: {
    url: `${BASE_URL}/manager/adminmanager.php`,
    method: "GET",
  },

  //representative api's

  createrepresentative: {
    url: `${BASE_URL}/representative/create.php`,
    method: "POST",
  },
  updaterepresentative: {
    url: `${BASE_URL}/representative/adminupdate.php`,
    method: "POST",
  },
  getAllrepresentative: {
    url: `${BASE_URL}/representative/adminrepresentative.php`,
    method: "GET",
  },

  getAllrepresentativenames: {
    url: `${BASE_URL}/representative/adminrepresentative.php`,
    method: "PUT",
  },

  // updatetheassignment: {
  //   url: `${BASE_URL}/representative/update_group_master_ids.php`,
  //   method: 'POST',
  // },

  updatethemainassignment: {
    url: `${BASE_URL}/representative/update_group_master_main.php`,
    method: "POST",
  },

  getActiveRepresentative: {
    url: `${BASE_URL}/representative/retrieve.php`,
    method: "GET",
  },

  getrepresentativeById: {
    url: `${BASE_URL}/representative/adminrepresentative.php`,
    method: "POST",
  },

  //dealer api's

  createdealer: {
    url: `${BASE_URL}/dealer/create.php`,
    method: "POST",
  },

  updatedealer: {
    url: `${BASE_URL}/dealer/adminupdate.php`,
    method: "POST",
  },

  updatedealerPermissions: {
    url: `${BASE_URL}/dealer/permission.php`,
    method: "POST",
  },
  AssignDealer: {
    url: `${BASE_URL}/dealer/updateActivation.php`,
    method: "POST",
  },
  getAlldealer: {
    url: `${BASE_URL}/dealer/admindealer.php`,
    method: "PUT",
  },

  getActiveDelaer: {
    url: `${BASE_URL}/dealer/retrieve.php`,
    method: "GET",
  },

  getdelearById: {
    url: `${BASE_URL}/dealer/retrieve.php`,
    method: "POST",
  },
  //Electrician api's

  createelectrician: {
    url: `${BASE_URL}/electrician/admincreate.php`,
    method: "POST",
  },

  updateelectrician: {
    url: `${BASE_URL}/electrician/adminupdate.php`,
    method: "POST",
  },
  getAllelectrician: {
    url: `${BASE_URL}/electrician/adminelectrician.php`,
    method: "GET",
  },

  getElectricianById: {
    url: `${BASE_URL}/electrician/adminelectrician.php`,
    method: "POST",
  },

  getElectriciandashboardById: {
    url: `${BASE_URL}/electrician/retrieve.php`,
    method: "POST",
  },

  getTodayelectrician: {
    url: `${BASE_URL}/electrician/adminelectrician.php`,
    method: "GET",
  },

  //SalesBoy api's

  createsalesboy: {
    url: `${BASE_URL}/sales_boy/create.php`,
    method: "POST",
  },
  updatesalesboy: {
    url: `${BASE_URL}/sales_boy/adminupdate.php`,
    method: "POST",
  },
  getAllsalesboy: {
    url: `${BASE_URL}/sales_boy/adminsalesboy.php`,
    method: "GET",
  },

  salesboyLimitValue: {
    url: `${BASE_URL}/sales_boy/adminsalesboy.php`,
    method: "PUT",
  },

  getSalesBoyById: {
    url: `${BASE_URL}/sales_boy/adminretrieve.php`,
    method: "POST",
  },

  //district api's
  createdistrict: {
    url: `${BASE_URL}/district/create.php`,
    method: "POST",
  },
  updatedistrict: {
    url: `${BASE_URL}/district/update.php`,
    method: "POST",
  },
  getAlldistrict: {
    url: `${BASE_URL}/district/admindistrict.php`,
    method: "GET",
  },

  getActivedistrict: {
    url: `${BASE_URL}/district/retrieve.php`,
    method: "PUT",
  },

  //states api's
  createstate: {
    url: `${BASE_URL}/state/create.php`,
    method: "POST",
  },
  updatestate: {
    url: `${BASE_URL}/state/update.php`,
    method: "POST",
  },
  getActiveState: {
    url: `${BASE_URL}/state/retrieve.php`,
    method: "GET",
  },
  getAllState: {
    url: `${BASE_URL}/state/adminstate.php`,
    method: "GET",
  },

  //qrcodes api's

  // createqrcodes: {
  //   url: `${BASE_URL}/qrcodes/create1.php`,
  //   method: 'POST',
  // },

  createqrcodes: {
    url: `${BASE_URL}/qrcodes/qr_create2.php`,
    method: "POST",
  },

  getAllqrcodes: {
    url: `${BASE_URL}/qrcodes/adminRetrieve.php`,
    method: "GET",
  },

  getdatefiltersqrcodes: {
    url: `${BASE_URL}/qrcodes/adminRetrieve.php`,
    method: "POST",
  },

  getLimitqrcodes: {
    url: `${BASE_URL}/qrcodes/adminRetrieve.php`,
    method: "PUT",
  },

  getfreshLimitqrcodes: {
    url: `${BASE_URL}/qrcodes/retrieve.php`,
    method: "PUT",
  },

  getSearchedqrDetails: {
    url: `${BASE_URL}/qrcodes/retrieve.php`,
    method: "POST",
  },

  getUsedqrcodesDateFilters: {
    url: `${BASE_URL}/electrician_used_qrcodes/retrieve.php`,
    method: "POST",
  },

  getUsedqrcodesLimitValue: {
    url: `${BASE_URL}/electrician_used_qrcodes/retrieve.php`,
    method: "PUT",
  },

  getqrusedcodes: {
    url: `${BASE_URL}/electrician_used_qrcodes/adminretrieve.php`,
    method: "GET",
  },

  getLimitValueqrusedcodes: {
    url: `${BASE_URL}/electrician_used_qrcodes/adminretrieve.php`,
    method: "PUT",
  },

  // updateqrusedcodes: {
  //   url: `${BASE_URL}/qrcodes/update.php`,
  //   method: 'POST',
  // },

  fetchqrisprintornot: {
    url: `${BASE_URL}/qrcodes/update.php`,
    method: "GET",
  },

  //ledger api's
  getelectricianLedgerById: {
    url: `${BASE_URL}/electrician_ledger/retrieve.php`,
    method: "POST",
  },

  getdealerLedgerById: {
    url: `${BASE_URL}/dealer_ledger/retrieve.php`,
    method: "POST",
  },

  getelectricianLedgerdatefilterById: {
    url: `${BASE_URL}/electrician_ledger/retrieve.php`,
    method: "PUT",
  },

  getdealerLedgerdatefilterById: {
    url: `${BASE_URL}/dealer_ledger/retrieve.php`,
    method: "PUT",
  },

  //transations api's
  getelectricianTransactionsById: {
    url: `${BASE_URL}/electrician_transaction/retrieve.php`,
    method: "POST",
  },

  //reeedem gifts
  getelectricianreedemgiftsById: {
    url: `${BASE_URL}/electrician_redeem_gift/retrieve.php`,
    method: "POST",
  },

  getdealerreedemgiftsById: {
    url: `${BASE_URL}/dealer_redeem_gift/retrieve.php`,
    method: "POST",
  },

  electricianLimitValue: {
    url: `${BASE_URL}/electrician/adminelectrician.php`,
    method: "PUT",
  },

  electricianDateTimeValue: {
    url: `${BASE_URL}/electrician/adminelectrician.php`,
    method: "PUT",
  },
  //gift card
  createGiftCard: {
    url: `${BASE_URL}/electrician_gift_scheme/create.php`,
    method: "POST",
  },
  updateGiftCard: {
    url: `${BASE_URL}/electrician_gift_scheme/update.php`,
    method: "POST",
  },
  getGiftCard: {
    url: `${BASE_URL}/electrician_gift_scheme/adminretrieve.php`,
    method: "GET",
  },

  createDealerGiftCard: {
    url: `${BASE_URL}/dealer_gift_scheme/create.php`,
    method: "POST",
  },

  updateDealerGiftCard: {
    url: `${BASE_URL}/dealer_gift_scheme/update.php`,
    method: "POST",
  },
  getDealerGiftCard: {
    url: `${BASE_URL}/dealer_gift_scheme/adminretrieve.php`,
    method: "GET",
  },

  //Electrician Redeem card

  getAllreedemgifts: {
    url: `${BASE_URL}/electrician_redeem_gift/adminretrieve.php`,
    method: "GET",
  },

  updatereedemgifts: {
    url: `${BASE_URL}/electrician_redeem_gift/dispatch_update.php`,
    method: "PUT",
  },

  getAllLIMITVALUEreedemgifts: {
    url: `${BASE_URL}/electrician_redeem_gift/adminretrieve.php`,
    method: "PUT",
  },

  getAllDATETIMEFILTERreedemgifts: {
    url: `${BASE_URL}/electrician_redeem_gift/adminretrieve.php`,
    method: "POST",
  },

  getelectriciangiftdispatch: {
    url: `${BASE_URL}/electrician_gift_dispatch/retrieve.php`,
    method: "POST",
  },

  //dealer reedem  gifts

  getAllDealerreedemgifts: {
    url: `${BASE_URL}/dealer_redeem_gift/adminretrieve.php`,
    method: "GET",
  },

  updateDealerreedemgifts: {
    url: `${BASE_URL}/dealer_redeem_gift/dispatch_update.php`,
    method: "PUT",
  },

  getAllLIMITVALUEDealerreedemgifts: {
    url: `${BASE_URL}/dealer_redeem_gift/adminretrieve.php`,
    method: "PUT",
  },

  getAllDATETIMEFILTERDealerreedemgifts: {
    url: `${BASE_URL}/dealer_redeem_gift/adminretrieve.php`,
    method: "POST",
  },

  getdealergiftdispatch: {
    url: `${BASE_URL}/dealer_gift_dispatch/retrieve.php`,
    method: "POST",
  },

  //counts

  getelectriciancounts: {
    url: `${BASE_URL}/dashboard/count.php`,
    method: "POST",
  },

  getPeronsDashboardcounts: {
    url: `${BASE_URL}/dashboard/count.php`,
    method: "GET",
  },

  getPeronsDashboardDealercounts: {
    url: `${BASE_URL}/dashboard/count.php`,
    method: "PUT",
  },

  getdealercounts: {
    url: `${BASE_URL}/dashboard/dealer_count.php`,
    method: "POST",
  },

  //Roles And Resposbilitys
  createrolesandresponsibilities: {
    url: `${BASE_URL}/roles_responsibilities/create.php`,
    method: "POST",
  },

  updaterolesandresponsibilities: {
    url: `${BASE_URL}/roles_responsibilities/update.php`,
    method: "POST",
  },

  fetchrolesandresponsibilitys: {
    url: `${BASE_URL}/roles_responsibilities/retrieve.php`,
    method: "POST",
  },

  // screens
  getscreennames: {
    url: `${BASE_URL}/screen/retrieve.php`,
    method: "GET",
  },

  //categorys

  getcategorynames: {
    url: `${BASE_URL}/dealer_products/category.php`,
    method: "POST",
  },

  getproductslist: {
    url: `${BASE_URL}/dealer_products/retrieve.php`,
    method: "PUT",
  },

  updateproductlist: {
    url: `${BASE_URL}/dealer_products/update.php`,
    method: "POST",
  },

  //orders
  getorderslist: {
    url: `${BASE_URL}/dealer_orderdetails/retrieve.php`,
    method: "GET",
  },
  getorderDetails: {
    url: `${BASE_URL}/dealer_orderdetails/retrieve.php`,
    method: "PUT",
  },

  getDealerorderHistory: {
    url: `${BASE_URL}/dealer_orderdetails/retrieve.php`,
    method: "POST",
  },

  getDealerorderHistoryById: {
    url: `${BASE_URL}/dealer_orderdetails/adminretrieve.php`,
    method: "POST",
  },

  getDealerorderDetailsRecentHistory: {
    url: `${BASE_URL}/dealer_orderdetails/recent.php`,
    method: "PUT",
  },

  updateOrderStatus: {
    url: `${BASE_URL}/dealer_orderdetails/update.php`,
    method: "POST",
  },

  updateHoldStatus: {
    url: `${BASE_URL}/dealer_redeem_gift/hold_update.php`,
    method: "POST",
  },

  electricianupdateHoldStatus: {
    url: `${BASE_URL}/electrician_redeem_gift/hold_update.php`,
    method: "POST",
  },

  updatependingImage: {
    url: `${BASE_URL}/dealer_redeem_gift/dispatch_update.php`,
    method: "POST",
  },

  updatependingElectricianImage: {
    url: `${BASE_URL}/electrician_redeem_gift/dispatch_update.php`,
    method: "POST",
  },

  electricianupdatedelivery: {
    url: `${BASE_URL}/electrician_redeem_gift/update.php`,
    method: "PUT",
  },

  delearupdatedelivery: {
    url: `${BASE_URL}/dealer_redeem_gift/update.php`,
    method: "PUT",
  },

  getdelearholdstatus: {
    url: `${BASE_URL}/dealer_gift_dispatch/hold_retrieve.php`,
    method: "POST",
  },

  getelectricianholdstatus: {
    url: `${BASE_URL}/electrician_gift_dispatch/hold_retrieve.php`,
    method: "POST",
  },

  //item management groups api's

  productGroupsByParentName: {
    url: `${BASE_URL}/dealer_stock_group/stock_group_retrieve.php`,
    method: "POST",
  },

  getProductDetails: {
    url: `${BASE_URL}/dealer_products/adminretrieve.php`,
    method: "POST",
  },

  updatestockGroupImage: {
    url: `${BASE_URL}/dealer_stock_group/stock_group_image_update.php`,
    method: "POST",
  },

  updatestockproductImage: {
    url: `${BASE_URL}/dealer_products/dealer_product_image_update.php`,
    method: "POST",
  },

  // getDealerorderDetailsRecentHistory: {
  //   url: "http://localhost/v1_systems/dealer_orderdetails/recent.php",
  //   method: 'PUT',
  // },

  updatebanners: {
    url: `${BASE_URL}/banners/banner_update.php`,
    method: "POST",
  },

  getbanners: {
    url: `${BASE_URL}/banners/banner_retrieve.php`,
    method: "GET",
  },

  // notification

  updateannouncement: {
    url: `${BASE_URL}/notification/notification_update.php`,
    method: "POST",
  },

  getannouncement: {
    url: `${BASE_URL}/notification/notification_adminretrieve.php`,
    method: "PUT",
  },

  //qr status display screen

  getqrtaskstatus: {
    url: `${BASE_URL}/qrcodes/qr_created_data.php`,
    method: "put",
  },

  getqrcodespdfbasedonthecreateddate: {
    url: `${BASE_URL}/qrcodes/qr_created_data.php`,
    method: "POST",
  },

  //rep

  getrepresentativesnames: {
    url: `${BASE_URL}/representative/names.php`,
    method: "GET",
  },

  getdealerslistbyrepresentative: {
    url: `${BASE_URL}/representative/dealer_retrieve.php`,
    method: "POST",
  },

  assigndealerstorepresentative: {
    url: `${BASE_URL}/dealer/adminupdate.php`,
    method: "PUT",
  },

  getdealersbydistrict: {
    url: `${BASE_URL}/dealer/district.php
`,
    method: "POST",
  },

  // get cancelled gifts

  notdispatched: {
    url: `${BASE_URL}/electrician_gift_dispatch/not_dispatch.php`,
    method: "GET",
  },

  notdispatcheddealer: {
    url: `${BASE_URL}/dealer_gift_dispatch/not_dispatch.php`,
    method: "GET",
  },

  //cancel gifts update

  canelgiftselectrician: {
    url: `${BASE_URL}/electrician_redeem_gift/cancel_update.php`,
    method: "POST",
  },

  canelgiftsdealer: {
    url: `${BASE_URL}/dealer_redeem_gift/cancel_update.php`,
    method: "POST",
  },

  getcountsofqrcodes: {
    url: `${BASE_URL}/qrcodes/count.php`,
    method: "GET",
  },

  //download retreive qr pdf's

  // updateqrusedcodes: {
  //   url: `${BASE_URL}/qrcodes/download_file.php`,
  //   method: 'POST',
  // },

  getqrusedpdfcodefile: {
    url: `${BASE_URL}/qrcodes/download_retrieve.php`,
    method: "POST",
  },
  downloadpdfcodefile: {
    url: `${BASE_URL}/qrcodes/download.php`,
    method: "GET",
  },

  getdealerorderdetailsbydatesfilters: {
    url: `${BASE_URL}/dealer_orderdetails/filter_retrieve.php`,
    method: "POST",
  },

  getdealerlogindetils: {
    url: `${BASE_URL}/dealer/login_retrieve.php`,
    method: "GET",
  },

  // employee login details

  createemployeelog: {
    url: `${BASE_URL}/employee_logs/log_create.php`,
    method: "POST",
  },

  getEmployeesloginDetails: {
    url: `${BASE_URL}/employee_logs/log_retrieve.php`,
    method: "PUT",
  },

  deleteemployeerecords: {
    url: `${BASE_URL}/employee_logs/delete.php`,
    method: "DELETE",
  },

  // TALLEY DATA all data

  getcompanymasterdata: {
    url: `${BASE_URL}/talley_data/company_master/admin_retrieve.php`,
    method: "GET",
  },

  getgroupmasterdata: {
    url: `${BASE_URL}/dealer_group_master/admin_retrieve.php`,
    method: "GET",
  },

  getdealerdebitnote: {
    url: `${BASE_URL}/talley_data/dealer_debit_note/admin_retrieve.php`,
    method: "PUT",
  },

  getdealercreditnote: {
    url: `${BASE_URL}/talley_data/dealer_credit_note/admin_retrieve.php`,
    method: "PUT",
  },

  getdealerpayment: {
    url: `${BASE_URL}/talley_data/dealer_payment/admin_retrieve.php`,
    method: "GET",
  },

  getdealerPuchase: {
    url: `${BASE_URL}/talley_data/dealer_purchase/admin_retrieve.php`,
    method: "GET",
  },

  getdealerSales: {
    url: `${BASE_URL}/talley_data/dealer_sales/admin_retrieve.php`,
    method: "PUT",
  },

  getdealerSalesledgerandbills: {
    url: `${BASE_URL}/talley_data/dealer_sales/admin_recent_data.php`,
    method: "PUT",
  },

  // TALLEY DATA 25 data  based on guid

  getdealerrecentcreditnote: {
    url: `${BASE_URL}/talley_data/dealer_credit_note/admin_recent_data.php`,
    method: "PUT",
  },

  getdealerrecentdebitnote: {
    url: `${BASE_URL}/talley_data/dealer_debit_note/admin_recent_data.php`,
    method: "POST",
  },

  getdealerpurchases: {
    url: `${BASE_URL}/talley_data/dealer_purchase/admin_recent_data.php`,
    method: "PUT",
  },

  getdealerjournal: {
    url: `${BASE_URL}/talley_data/dealer_journal/admin_recent_data.php`,
    method: "PUT",
  },

  getdealerrecipt: {
    url: `${BASE_URL}/talley_data/dealer_receipt/admin_recent_data.php`,
    method: "PUT",
  },

  getdealerpayments: {
    url: `${BASE_URL}/talley_data/dealer_payment/admin_recent_data.php`,
    method: "PUT",
  },

  // TALLEY DATA based on guid

  getdealercreditnotebyguid: {
    url: `${BASE_URL}/talley_data/dealer_credit_note/admin_retrieve.php`,
    method: "POST",
  },

  getdealerdebitnotebyguid: {
    url: `${BASE_URL}/talley_data/dealer_debit_note/admin_retrieve.php`,
    method: "POST",
  },

  getdealerpurchasehistorybyguid: {
    url: `${BASE_URL}/talley_data/dealer_purchase/admin_retrieve.php`,
    method: "POST",
  },

  getdealersaleshistorybyguid: {
    url: `${BASE_URL}/talley_data/dealer_sales/admin_retrieve.php`,
    method: "POST",
  },

  getdealerjournalhistorybyguid: {
    url: `${BASE_URL}/talley_data/dealer_journal/admin_retrieve.php`,
    method: "POST",
  },

  getdealerpaymenthistorybyguid: {
    url: `${BASE_URL}/talley_data/dealer_payment/admin_retrieve.php`,
    method: "POST",
  },

  // search by dealer

  getsearchbydealernameormobilenumber: {
    url: `${BASE_URL}/dealer/dealer_search.php`,
    method: "POST",
  },

  getsearchbyelectriciannameormobilenumber: {
    url: `${BASE_URL}/electrician/electrician_search.php`,
    method: "POST",
  },

  // groups count

  getitemscount: {
    url: `${BASE_URL}/talley_data/dealer_stock_items/items_count.php`,
    method: "GET",
  },

  //sales count
  getgroupscount: {
    url: `${BASE_URL}/talley_data/dealer_sales/sales_count.php`,
    method: "GET",
  },

  getdealeroddetailsnyguid: {
    url: `${BASE_URL}/talley_data/dealer_ledger/dealer_retrieve.php`,
    method: "POST",
  },

  getsalescount: {
    url: `${BASE_URL}/talley_data/dealer_sales/sales_count.php`,
    method: "POST",
  },

  //sales returns count

  getDealerSalesAmount: {
    url: `${BASE_URL}/talley_data/dealer_ledger/dealer_count.php`,
    method: "POST",
  },

  dealerSalesAndReturns: {
    url: `${BASE_URL}/talley_data/dealer_sales_returns/dealer_sales_returns.php`,
    method: "POST",
  },

  dealerSalesByID: {
    url: `${BASE_URL}/talley_data/dealer_sales_returns/sales_credit_retrieve.php`,
    method: "PUT",
  },

  dealerCreditNoteByID: {
    url: `${BASE_URL}/talley_data/dealer_sales_returns/sales_credit_retrieve.php`,
    method: "POST",
  },

  dealerDebitNoteByID: {
    url: `${BASE_URL}/talley_data/dealer_sales_returns/debit_note_retrieve.php`,
    method: "POST",
  },

  searchdealersalesbyvochur: {
    url: `${BASE_URL}/talley_data/dealer_sales_returns/sales_returns_search.php`,
    method: "POST",
  },

  imageuploadbysalesid: {
    url: `${BASE_URL}/talley_data/dealer_sales/image_update.php`,
    method: "POST",
  },

  imageuploadbycreditnoteimageid: {
    url: `${BASE_URL}/talley_data/dealer_credit_note/credit_image_update.php`,
    method: "POST",
  },

  imageuploadbydebitnoteimageid: {
    url: `${BASE_URL}/talley_data/dealer_debit_note/image_update.php`,
    method: "POST",
  },

  getdealerledgercopy: {
    url: `${BASE_URL}/talley_data/dealer_ledger/dealer_transactions.php`,
    method: "POST",
  },

  getdaybookalltransactions: {
    url: `${BASE_URL}/talley_data/dealer_ledger/dealer_today_transactions.php`,
    method: "POST",
  },

  getsalescountfordashboard: {
    url: `${BASE_URL}/talley_data/dealer_sales/app_retrieve.php`,
    method: "POST",
  },

  createledgerstatementclosingbalance: {
    url: `${BASE_URL}/talley_data/dealer_ledger_statement/statement_create.php`,
    method: "POST",
  },

  getledgerstatementclosingbalance: {
    url: `${BASE_URL}/talley_data/dealer_ledger_statement/statement_retrieve.php`,
    method: "POST",
  },

  ledgerbalance: {
    url: `${BASE_URL}/talley_data/dealer_ledger/dealer_ledger_balance.php`,
    method: "POST",
  },

  ledgerodcalculationcndn: {
    url: `${BASE_URL}/talley_data/dealer_od_calculation/credit_debit_retrieve.php`,
    method: "POST",
  },

  // ledgerodcalculationjournal: {
  //   url: `${BASE_URL}/talley_data/dealer_od_calculation/od_calculation_retrieve.php`,
  //   method: 'POST'
  // },

  ledgerodcalculationjournal: {
    url: `${BASE_URL}/talley_data/dealer_od_calculation/od_calculation_retrieve1.php`,
    method: "POST",
  },

  duplicateGUIDS: {
    url: `${BASE_URL}/talley_data/duplicate_guids/transactions_retrieve.php`,
    method: "GET",
  },

  creditDayLimits: {
    url: `${BASE_URL}/talley_data/dealer_ledger/cr_limits_guid.php`,
    method: "POST",
  },

  // partypedningoverduebillsbalanceamounts: {
  //   url: `${BASE_URL}/talley_data/dealer_od_calculation/get_party_total_balance.php`,
  //   method: 'POST'
  // },

  partypedningoverduebillsbalanceamounts: {
    url: `${BASE_URL}/talley_data/dealer_od_calculation/get_party_total_balance1.php`,
    method: "POST",
  },

  getpartydealeroverduecountsbalance: {
    url: `${BASE_URL}/talley_data/representative/get_party_total_balance1.php`,
    method: "POST",
  },

  // partyOdoverduebills: {
  //    url: `${BASE_URL}/talley_data/dealer_od_calculation/overdue_cal_retrieve.php`,
  //   method: 'POST'
  // },

  partyOdoverduebills: {
    url: `${BASE_URL}/talley_data/dealer_od_calculation/overdue_cal_retrieve1.php`,
    method: "POST",
  },
  dealerdiscounts: {
    url: `${BASE_URL}/talley_data/dealer_ledger/discounts_by_guid.php`,
    method: "POST",
  },

  dealeronaccount: {
    url: `${BASE_URL}/talley_data/dealer_on_account/no_bill_transactions.php`,
    method: "POST",
  },

  dealeronaccountcount: {
    url: `${BASE_URL}/talley_data/dealer_on_account/no_bill_transaction_count.php`,
    method: "GET",
  },

  dealerMonthWiseReports: {
    url: `${BASE_URL}/talley_data/dealer_sales/app_retrieve.php`,
    method: "POST",
  },

  dealerMonthWiseOpeningBalance: {
    url: `${BASE_URL}/talley_data/dealer_ledger/dealer_month_wise_opb.php`,
    method: "POST",
  },

  // delaer group master

  dealergroupmasterfetchdealers: {
    url: `${BASE_URL}/dealer_group_master/admin_dealer_retrieve.php`,
    method: "POST",
  },

  dealergroupmasterparent: {
    url: `${BASE_URL}/dealer_group_master/admin_group_maser_parents.php`,
    method: "POST",
  },

  dealergroupnamesbymastername: {
    url: `${BASE_URL}/dealer_group_master/group_master_parents.php`,
    method: "PUT",
  },

  dealerinfo: {
    url: `${BASE_URL}/dealer/dealer_representative_retrieve.php`,
    method: "POST",
  },

  dealermonthwiseoverallreports: {
    url: `${BASE_URL}/talley_data/dealer_ledger/dealer_performance.php`,
    method: "POST",
  },

  dealersearchbyparentname: {
    url: `${BASE_URL}/dealer_group_master/group_master_search.php`,
    method: "POST",
  },

  dealerCardStatusCreateOrUpdate: {
    url: `${BASE_URL}/dealer_card/dealer_card_create.php`,
    method: "POST",
  },

  productsisactiveupdate: {
    url: `${BASE_URL}/dealer_products/is_active_update.php`,
    method: "POST",
  },

  groupsisactiveupdate: {
    url: `${BASE_URL}/dealer_stock_group/stock_group_active_update.php`,
    method: "POST",
  },

  fetchgroupsrepresentativesindropdown: {
    url: `${BASE_URL}/dealer_group_master/representative_retrieve.php`,
    method: "POST",
  },

  updatedealergroupmaster: {
    url: `${BASE_URL}/dealer_group_master/group_master_update.php`,
    method: "PUT",
  },

  representativeorderapproval: {
    url: `${BASE_URL}/representative/order_approve_update.php`,
    method: "POST",
  },

  dealerordercreationbyimage: {
    url: `${BASE_URL}/dealer_orderdetails/image.php`,
    method: "POST",
  },

  dealerordercreationproduct: {
    url: `${BASE_URL}/dealer_orderdetails/create.php`,
    method: "POST",
  },

  requestapprovalupdatefororder: {
    url: `${BASE_URL}/dealer_orderdetails/approval_update.php`,
    method: "PUT",
  },

  dealersearchproduct: {
    url: `${BASE_URL}/dealer_products/search.php`,
    method: "POST",
  },

  representiveparent_groupmaster_id: {
    url: `${BASE_URL}/dealer_group_master/representative_main_retrieve.php`,
    method: "GET",
  },

  updateqrusedcodes: {
    url: `${BASE_URL}/qrcodes/download_file_single.php`,
    method: "POST",
  },

  updatenewqrcodebatchwise: {
    url: `${BASE_URL}/qrcodes/qr_update.php`,
    method: "POST",
  },

  getdealerpasswordbyguid: {
    url: `${BASE_URL}/dealer/dealer_retrieve.php`,
    method: "POST",
  },

  // dealer products

  getdealerActiveproducts: {
    url: `${BASE_URL}/dealer_products/adminretrieve.php`,
    method: "PUT",
  },

  getDealerActiveGroups: {
    url: `${BASE_URL}/dealer_stock_group/stock_group_retrieve.php`,
    method: "PUT",
  },

  // monthwise reports

  dealerMonthWiseReports: {
    url: `${BASE_URL}/talley_data/dealer_sales/app_retrieve.php`,
    method: "POST",
  },

  dealerMonthWiseOpeningBalance: {
    url: `${BASE_URL}/talley_data/dealer_ledger/dealer_month_wise_opb.php`,
    method: "POST",
  },
  dealerholdorder: {
    url: `${BASE_URL}/dealer_orderdetails/hold_update.php`,
    method: "POST",
  },
  dealerorderrequest: {
    url: `${BASE_URL}/dealer_orderdetails/order_request.php`,
    method: "POST",
  },
  requestupdate: {
    url: `${BASE_URL}/dealer_orderdetails/approval_update.php`,
    method: "PUT",
  },

  approvalupdatefororder: {
    url: `${BASE_URL}/dealer_orderdetails/approval_update.php`,
    method: "POST",
  },

  alloverduecount: {
    url: `${BASE_URL}/talley_data/representative/admin_total_balance.php`,
    method: "GET",
  },
};


export default API_URLS;
